import axios from 'axios';
import { API_URL } from 'config/URL/URL';

const DEFAULT_SRS = 'EPSG:3857';

const buildExtentParam = (extent) => {
    if (!extent || extent.length !== 4) {
        return undefined;
    }
    return extent.join(',');
};

export const fetchHousingInfo = async ({ extent, housingParams = {}, layerName }) => {
    const response = await axios.get(`${API_URL}/house/getInfo`, {
        params: {
            extent: buildExtentParam(extent),
            apt: housingParams.apartment,
            dsd: housingParams.multiFamily,
            off: housingParams.officetel,
            min: housingParams.minArea,
            max: housingParams.maxArea,
            srsname: DEFAULT_SRS,
            layerName,
            outputFormat: 'application/json',
        },
    });

    return response.data;
};

